import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {OfferModal} from "../../../offer/components/offer_modal/OfferModal";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {IOfferModalOffer} from "../../../offer/types/OfferModalOffer";
import {useAppSelector} from "../../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {FilterPresets, useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";

interface IProps {
    vendorId: number;
    region: number | null;
    items: IOfferModalOffer[];
}

const modalName: IOfferModalName = "mainOfferModal";

export function VendorDetailOfferModal(props: IProps) {
    const {vendorId, region, items} = props;

    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);

    const userPreferencesFilters = useUserPreferencesFilters(FilterPresets.WithoutRegion);

    const payload = convertToVendorDetailViewOffersPayload({vendorId: vendorId, region, displayType: OfferDisplayType.FOR_SALE});
    const {data, isSuccess, isLoading, isFetching, isError, isUninitialized} = useGetVendorDetailOffersQuery({
        ...payload,
        page
    });

    const query: IInfiniteListQuery<IOfferModalOffer> = {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError}),
        data: items ? items : data ? data.results : [],
        count: data ? data.count : 0,
        page,
        pageSize
    };

    return <OfferModal modalName={modalName} offersQuery={query} userPreferencePropertyFilters={userPreferencesFilters} />;
}
import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {OfferModal} from "../../../offer/components/offer_modal/OfferModal";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {IOfferModalOffer} from "../../../offer/types/OfferModalOffer";
import {useAppSelector} from "../../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {FilterPresets, useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";

interface IProps {
    vendorId: number;
    region: number | null;
    items: IOfferModalOffer[];
}

const modalName: IOfferModalName = "mainOfferModal";

export function VendorDetailOfferModal(props: IProps) {
    const {vendorId, region, items} = props;

    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);

    const userPreferencesFilters = useUserPreferencesFilters(FilterPresets.WithoutRegion);

    const payload = convertToVendorDetailViewOffersPayload({vendorId: vendorId, region, displayType: OfferDisplayType.FOR_SALE});
    const {data, isSuccess, isLoading, isFetching, isError, isUninitialized} = useGetVendorDetailOffersQuery({
        ...payload,
        page
    });

    const query: IInfiniteListQuery<IOfferModalOffer> = {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError}),
        data: items ? items : data ? data.results : [],
        count: data ? data.count : 0,
        page,
        pageSize
    };

    return <OfferModal modalName={modalName} offersQuery={query} userPreferencePropertyFilters={userPreferencesFilters} />;
}
